{
  "completed": "完了 :",
  "current": "現在 :",
  "notCompleted": "未完了 :",
  "steplist": "手順リスト"
}
